// extracted by mini-css-extract-plugin
export default {"container":"GuestLayout_container__IA8Ua"};